import React, { useEffect, useState } from 'react'
import checkoutStyles from '../ProductCheckoutPage/styles.module.css'
import pairsWellWithStyles from '../ProductCheckoutPage/PairsWellWith/styles.module.css'
import { http } from '../../../../utils/clientHttp'
import { useRegionCountryCode, useRegionShippingInfo } from '../../../RegionGeo'
import { useUiStore } from '../../../../store/uiStore'
import { useCartStore, selectCart } from '../../../../store/cartStore'
import { useAddToCart } from '../../../hooks/useAddToCart'
import useProductOffers from '../../../../hooks/useProductOffers'
import { $neutralGray70, $red60 } from '../../../../styles/colors/primitives'
import { CircularProgress } from '@mui/material'
import Text from '../../../Text'
import {
  calculateDiscountFromRegularPriceCents,
  calculatePriceForMultipleShopItems,
  isBundle,
  isInCart
} from '../../../../utils/shopItemsAndCart'
import CtaV2 from '../../../CtaV2'
import { addCentsToPrice } from '../../../../utils/prices'
import CartIcon from '../../../icons/CartIcon'
import ItemSpecifications from '../Utils/ItemSpecifications'
import {
  allItemsAreAvailable,
  findItemByType,
  getOptionalItems, isOutOfStock,
  isPreOrder
} from '../../../../utils/shopItems'
import PairsWellWith from '../ProductCheckoutPage/PairsWellWith'
import { handleCheckbox } from '../../../../utils/arrays'
import Spacer from '../../../Spacer'
import CheckmarkIcon from '../../../icons/CheckmarkIcon'
import PreOrderWarningModal from '../ProductCheckoutPage/PreOrderWarningModal'
import { $preOrder } from '../../../../styles/colors/semantics'
import Description from '../ProductCheckoutPage/Description'
import SimpleBlockContent from '../../../SimpleBlockContent'
import BundleSpecifications from '../Utils/ItemSpecifications/BundleSpecifications'
import { Page404 } from '../../index'
import SecondaryNavbarAddToCart from '../ProductCheckoutPage/SecondaryNavbarAddToCart'
import Img from '../../../Img'
import Offer from '../ProductCheckoutPage/Offer'
import ProductInfoTags from '../ProductCheckoutPage/ProductInfoTags'
import Subtotal from '../ProductCheckoutPage/Subtotal'
import InputField from '../../Pages/PaymentPage/AddressInput/InputField'

// Promotional uDFP20 hero — bucket-hosted + optimized via the #67 asset pipeline
// (`web/scripts/asset.mjs add`), resolved here to a ResolvedImage descriptor so
// it renders through <Img>/<OptimizedImage> with a reserved aspect-ratio box (no
// CLS) and the WebP variant ladder instead of the raw 300 KB jpeg. The srcSet /
// src / placeholder mirror lib/resolveImage.js's variantDescriptor for this asset
// (assetId 7be57176…, intrinsic 1254×1254 → ladder [384,640,828,1200]); the media
// base is env-gated exactly as the resolver does (absolute bucket URL in prod,
// relative in dev) so render HTML stays byte-identical to the framework's output.
const UDFP20_HERO_ID = '7be57176ba3a08a8af9de5fc8d3f11b7cda59b0c'
const UDFP20_HERO_MEDIA_BASE =
  process.env.NODE_ENV === 'production' ? 'https://storage.googleapis.com/vrs-media' : ''
const udfp20HeroVariant = (w) => `${UDFP20_HERO_MEDIA_BASE}/assets/images/variants/${UDFP20_HERO_ID}-${w}.webp`
const UDFP20_PROMO_IMAGE = {
  src: udfp20HeroVariant(1200),
  srcSet: [384, 640, 828, 1200].map((w) => `${udfp20HeroVariant(w)} ${w}w`).join(', '),
  width: 1254,
  height: 1254,
  aspectRatio: 1,
  placeholderUrl: udfp20HeroVariant(384),
  placeholderSrc: udfp20HeroVariant(384),
  alt: 'uDFP20 Torque Upgrade — 6 Nm to 20 Nm',
}

const cx = (...c) => c.filter(Boolean).join(' ')

function UDFP20UpgradesCheckoutPage({ itemType, fallbackItemType, itemOptionsText, title, showOptionWithAllItemsInSet, overrideDescription, importantInfo, sortByPriceDescending }) {
  // newRegion + shippingInfo migrated to the RegionGeo seam (Phase C2 part 2);
  // offers (incl. shopItemsFetched) migrated off Overmind onto useProductOffers /
  // the offers store (Phase D1). The Zustand cart stays as-is. Mixed file.
  const newRegion = useRegionCountryCode()
  const shippingInfo = useRegionShippingInfo()
  // Cart line items now come from the Zustand cart store (Bucket C); the cart panel
  // + pre-order modal flags from the Zustand ui store (Phase C2 part 1).
  const shoppingCart = useCartStore(selectCart)
  const openCart = useUiStore((s) => s.openCart)
  const openPreOrderWarning = useUiStore((s) => s.openPreOrderWarning)
  const { checkoutPageAddToCart } = useAddToCart()

  // Shared product-checkout data logic (refetch gate + main-item resolution +
  // gallery helper) lives in useProductOffers so all four checkout forks stay in
  // lockstep (task #95). This page's specifics — the serial-number-driven offers
  // lookup and the promotional hero prepended to the carousel — are kept here.
  // `offers: shopItems` (server-threaded / full-after-refetch offers) replaces the
  // render-time `state.shopItems` reads below (byte-identical value throughout).
  // newRegion + shippingInfo migrated off Overmind (Phase C2 part 2, see above);
  // state.shopItems (offers) stays on Overmind. Aliased to `shopItems` to avoid colliding with
  // this page's local `offers` (the serial-number-driven offer list).
  const { item, getOfferImages, offers: shopItems, shopItemsFetched } = useProductOffers({ itemType, fallbackItemType })

  const [selectedOfferIndex, setSelectedOfferIndex] = useState(0)
  const [selectedOptionalIndexes, setSelectedOptionalIndexes] = useState([])
  const [serialNum, setSerialNum] = useState(null)
  const [offerIdsForSerial, setOfferIdsForSerial] = useState([])
  const [serialNumErrorMessage, setSerialNumErrorMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  let serialNumTemp = serialNum

  useEffect(() => {
    if (shopItemsFetched && offers && offers.length) {
      let preSelectedIndex = offers.findIndex(o => allItemsAreAvailable(o))
      setSelectedOfferIndex(preSelectedIndex >= 0 ? preSelectedIndex : 0)
    }
  }, [shopItemsFetched])

  useEffect(() => {
    if (!!serialNum) {
      setIsLoading(true)
      setSerialNumErrorMessage(null)
      console.log(serialNum)
      http.post('/api/getUpgradeOptionsForUDFP20Device', { country: newRegion, serialNumber: serialNum })
        .then((response) => {
          console.log('response', response)
          setOfferIdsForSerial(response.data)
          setIsLoading(false)
        })
        .catch((e) => {
          console.log('Bad request', e)
          if (e.response && e.response.status === 499) {
            // The backend sends a plain-text reason (never-activated / unknown serial).
            // Anything else (JSON envelope from the route helper) gets the generic line.
            const reason = e.response.data
            setSerialNumErrorMessage(typeof reason === 'string' && reason
              ? reason
              : 'We found no offers for serial number ' + serialNum + ', please contact support.')
          }
          setIsLoading(false)
        })
    }
  }, [ serialNum ])


  if (!shopItemsFetched) {
    return (
      <div className={checkoutStyles.loading} style={{ color: $neutralGray70 }}>
        <CircularProgress color="inherit"/>
      </div>
    )
  }

  if (!item) {
    return getItemNotFoundPage()
  }

  const offers = offerIdsForSerial.map(o => [o])

  console.log(offers)

  // main offer is the first item in list, it contains all items from product set
  const isMainOfferInCart = offers[0] && offers[0].every(i => isInCart(i, shoppingCart))
  const optionalItems = getOptionalItems(item, shopItems, false).filter(i => i.productSetId !== item.productSetId)
  const noOffersAvailable = !offers || !offers.length
  const description = item.fullSetDescription || item.description

  const getSelectedItems = () => {
    if (!offers || !offers.length) {
      return []
    }

    if (isMainOfferInCart) {
      // if main item is already added in cart
      // selected items are - main item + all optional items in cart, so subtotal can be calculated correctly
      return Array.from(offers[0]).concat(optionalItems.filter(i => isInCart(i, shoppingCart)))
    }

    const selectedMainOffer = offers[selectedOfferIndex]
    const selectedOptionalItems = Array.from(new Set(selectedOptionalIndexes)).flatMap(id => optionalItems[id])

    return Array.from(selectedMainOffer).concat(selectedOptionalItems).filter(o => !!o)
  }

  const getPreOrderInfo = () => {
    if (allItemsAreAvailable(getSelectedItems()) && selectionIsPreOrder(getSelectedItems())) {
      return (
        <div className={checkoutStyles.preOrderWrapper}>
          <Text type="heading-6">Pre-Order Now: Be the First to Get It!</Text>
          <Text type="regular">Our latest product is here for pre-order! Shipping is expected after the holiday season as we perfect every detail.</Text>
          <Text type="heading-8">Pre-order now to:</Text>
          <Text type="regular">•  Secure Your Spot before the rush.</Text>
          <Text type="regular">•  Get Updates on shipping timelines.</Text>
          <Text type="heading-8">Estimated delivery:</Text>
          <Text type="regular">•  after Christmas and New Year.</Text>
          <Text type="regular">Don’t miss out — order today and start the new year with something amazing!</Text>
        </div>
      )
    }
  }

  const getAddToCartCta = (isMainCta) => {
    const preOrderItem = getSelectedItems().find(i => i.preOrderInfo && i.preOrderInfo.isPreOrderAvailable)
    const isPreOrder = !!preOrderItem

    return {
      title: isMainOfferInCart ? 'Item added' : (isPreOrder ? 'Pre-order' : 'Add to cart'),
      titleIcon: isMainOfferInCart ? <CheckmarkIcon/> : (isMainCta ? <CartIcon large/> : <CartIcon/>),
      light: isMainOfferInCart,
      sx: {
        height: isMainCta ? '80px' : null,
        titleTextType: isMainCta ? 'large' : null,
        background: isPreOrder ? $preOrder : null,
      },
      disabled: !getSelectedItems().length || !allItemsAreAvailable(getSelectedItems()),
      onClick: () => {
        if (isMainOfferInCart) {
          openCart()
        } else if (isPreOrder) {
          openPreOrderWarning({ ...preOrderItem.preOrderInfo })
        } else {
          onAddToCartClick()
        }
      }
    }
  }

  const onAddToCartClick = () => checkoutPageAddToCart(getSelectedItems().map(i => i.id))

  const getSubtotal = () => {
    return calculatePriceForMultipleShopItems(getSelectedItems())
  }

  const getSubtotalDiscountedCents = () => {
    return calculateDiscountFromRegularPriceCents(getSelectedItems())
  }


  return (
    <>
      <SecondaryNavbarAddToCart
        title={title}
        subtotal={getSubtotal()}
        subtotalBeforeDiscount={addCentsToPrice(getSubtotal(), getSubtotalDiscountedCents())}
        ctaV2={getAddToCartCta(false)}
      />
      <PreOrderWarningModal onAddToCart={onAddToCartClick}/>
      <div className={checkoutStyles.wrapper}>
        {/* Single static promo hero (no gallery), so force wide=false: the
            ContentWrapper is a centered 1440px block (like the bundle pages),
            not full-viewport width — otherwise the text column is pinned to the
            far-right edge. justify-content:center centers the image+text pair.
            The image fills a capped column so it sits directly next to the text
            at a normal product-image size (not the full ~940px). paddingTop keeps
            it off the sticky navbar. It renders via a static responsive <Img>
            instead of the shared Carousel, which is layout="fill" and collapses
            to zero height on desktop (#67). */}
        <div className={checkoutStyles.contentWrapper} style={{ justifyContent: 'center' }}>
          <div className={checkoutStyles.desktopCarousel} style={{ maxWidth: '600px', paddingTop: '64px' }}>
            <div style={{ width: '100%' }}>
              <Img image={UDFP20_PROMO_IMAGE} layout="responsive" objectFit="contain"/>
            </div>
          </div>
          <div className={checkoutStyles.productInfo}>
            <div className={checkoutStyles.productText}>
              <div className={checkoutStyles.productTitle}>
                <Text type="heading-10">VRS® DirectForce®</Text>
                <Text type="heading-3" primary>{title || item.name}</Text>
              </div>
              <Description overrideDescription={overrideDescription} description={description}/>
              { importantInfo && <SimpleBlockContent blocks={importantInfo}/> }
            </div>
            <div className={checkoutStyles.mobileCarousel}>
              <div style={{ width: '100%', maxWidth: '280px', margin: '0 auto' }}>
                <Img image={UDFP20_PROMO_IMAGE} layout="responsive" objectFit="contain"/>
              </div>
            </div>
            <div className={checkoutStyles.checkout}>
              <div className={checkoutStyles.serialNumberInputWrapper}>
                <InputField
                  labelText="Enter your device serial number"
                  value={serialNumTemp}
                  placeholder="001XXXXXX or 001-XXXXXX"
                  required
                  onChange={(value) => serialNumTemp = (value ? value.replace('-', '') : '')}
                />
                <CtaV2 title="Find upgrade options" dark onClick={() => setSerialNum(serialNumTemp)}
                       sx={{ titleTextType: 'small', height: '64px', width: '60%' }}/>
                { serialNumErrorMessage && <Text type="small" color={$red60}>{serialNumErrorMessage}</Text> }
              </div>
              {
                (() => {
                  if (isLoading) {
                   return (
                     <div className={checkoutStyles.loadingSerialNumberFetch} style={{ color: $neutralGray70 }}>
                      <CircularProgress color="inherit"/>
                    </div>
                   )
                  } else if (!offers || !offers.length) {
                    // When the backend explained why (499 with a reason), that reason is already
                    // shown in red under the serial input; don't stack the generic line under it.
                    return serialNum && !serialNumErrorMessage && <Text type="regular">{'We found no offers for serial number ' + serialNum + ', please contact support.' }</Text>
                  } else {
                    return (
                      <div className={checkoutStyles.offers}>
                      { itemOptionsText && <><Text type="heading-8">{itemOptionsText}</Text><Spacer size={16}/></> }
                      {
                        offers.map((o, i) => <Offer
                          key={`offer-${i}`}
                          items={o}
                          isOutOfStock={!allItemsAreAvailable(o)}
                          isNew={!!o.some(i => i.isNew)}
                          isSelected={selectedOfferIndex === i}
                          onClick={() => {
                            setSelectedOfferIndex(i)
                          }}
                        />)
                      }
                    </div>
                    )
                  }
                }) ()
              }
              <div className={cx(pairsWellWithStyles.pairsWellWithWrapper, !(optionalItems && optionalItems.length) && pairsWellWithStyles.pairsWellWithWrapperHidden)}>
                <div>
                  <Text type="heading-9">Pairs well with</Text>
                  <Spacer size={8}/>
                </div>
                {
                  optionalItems.map((o, i) => <PairsWellWith
                      key={o.name}
                      item={o}
                      isItemInCart={isInCart(o, shoppingCart)}
                      isMainOfferInCart={isMainOfferInCart}
                      onCheckboxClick={() => handleCheckbox(selectedOptionalIndexes, i, (list) => setSelectedOptionalIndexes(list))}
                      isSelected={selectedOptionalIndexes.includes(i)}
                      isAvailable={!isOutOfStock(o)}
                    />
                  )}
              </div>
              {
                noOffersAvailable
                  ? null
                  : (
                    <div className={checkoutStyles.subtotalAndPreOrder}>
                      <Subtotal
                        subtotal={getSubtotal()}
                        discountCents={getSubtotalDiscountedCents()}
                        taxIncluded={item && item.taxIncluded}
                        cta={getAddToCartCta(true)}
                      />
                      {/*{ getPreOrderInfo() }*/}
                    </div>
                  )}
              {!noOffersAvailable && <ProductInfoTags transitTimeDays={selectionIsPreOrder(getSelectedItems()) ? null : shippingInfo.transitTimeDays}/>}
            </div>
            {
              isBundle(item) && !item.specs
                ? <BundleSpecifications items={item.bundledItemTypes.map(i => findItemByType(i, shopItems))} theme={'light'}/>
                : <ItemSpecifications specs={item.specs} theme={'light'}/>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const selectionIsPreOrder = (selectedItems) => {
  return selectedItems.some(i => isPreOrder(i))
}

const getItemNotFoundPage = () => {
  return <Page404 titleTextOverride={ <Text type="heading-2">Item not available for your location.</Text> }
                  ctasV2={[
                    { title: 'Return to shop', routeOrUrl: { url: '/shop' } },
                    { title: 'Contact support', routeOrUrl: { url: '/contact' }, dark: true },
                  ]}
  />
}

export default UDFP20UpgradesCheckoutPage
